// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('landingPage')
  .directive('giLandingTile', ($interval, $compile) => ({
    link(scope, elem, attr) {
      const layers = elem.find('> a');
      const randomIndex = Math.floor(Math.random() * layers.length);
      const activeTile = layers[randomIndex];
      angular.forEach(layers, function (tile, index) {
        if (index !== randomIndex) {
          return $(tile).removeClass('active');
        }
      });
      if (randomIndex === 0) {
        // The first tile loads ready to go.
        $(activeTile).addClass('active');
      } else {
        const caption = $(activeTile).html();
        const image = $(activeTile).data().src;
        const vPosition = $(activeTile).data().vPosition || 'center';
        const hPosition = $(activeTile).data().hPosition || 'center';
        $(activeTile)
          .addClass('active')
          .css('background-image', `url(${image})`)
          .css('background-position', `${hPosition} ${vPosition}`);
        $(activeTile).html(
          `<figure><img src=\"${image}\" /><figcaption>${caption}</figcaption>`
        );
      }
      $(activeTile).click(function () {
        if (window.combinedGtmTracking != null) {
          window.combinedGtmTracking.setUIElementLocation(
            'creative_category_link'
          );
        }
      });
      return false;
    },
  }));
